import { addWeeks, isAfter, isBefore, subWeeks } from "date-fns";
import React from "react";
import { isTheSameDate } from "../date";

const noop = () => true;

/**
 * Allows to move a week forward/backward on a list of data where each item in the list represents one week.
 * Also handles a situation when there are "missing" weeks in the data list.
 *
 * A "range" - is a period from oldest entry in the list to the newest one
 */
export function useWeeklyPagination(weeklyData) {
  const newestAvailableWeek = new Date(weeklyData[0].week_start_date);
  const oldestAvailableWeek = new Date(
    weeklyData[weeklyData.length - 1].week_start_date
  );
  const [weekStartDate, setWeekStartDate] = React.useState(newestAvailableWeek); // current week

  React.useEffect(() => {
    // reset
    setWeekStartDate(newestAvailableWeek);
  }, [weeklyData]);

  const weekStartDatePrev = subWeeks(weekStartDate, 1);
  const weekStartDateNext = addWeeks(weekStartDate, 1);
  const isPrevWeekWithinRange = !isBefore(
    weekStartDatePrev,
    oldestAvailableWeek
  );
  const isNextWeekWithinRange = !isAfter(
    weekStartDateNext,
    newestAvailableWeek
  );

  const goBackOneWeek = () => {
    setWeekStartDate(weekStartDatePrev);
  };

  const goForwardOneWeek = () => {
    setWeekStartDate(weekStartDateNext);
  };

  const getCurrentWeekData = (filter = noop) =>
    weeklyData.find(
      week =>
        isTheSameDate(new Date(week.week_start_date), weekStartDate) &&
        filter(week)
    );

  return {
    isPrevWeekWithinRange,
    isNextWeekWithinRange,
    weekStartDatePrev,
    weekStartDate,
    weekStartDateNext,
    goBackOneWeek,
    goForwardOneWeek,
    getCurrentWeekData,
  };
}
